import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa-svg'
import { VCol } from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import { ko } from 'vuetify/locale'

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    components: {
      VCol,
      ...labsComponents
    },
    locale: { //캘린더 등의 한글 설정 위한 코드 250701 이우석
      locale: 'ko',
      fallback: 'en',
      messages: { ko }
    },
    display: {
      mobileBreakpoint: 'sm',
      thresholds: {
        xs: 0,
        sm: 577,
        md: 768,
        lg: 992,
        xl: 1200,
      },
    },
    icons: {
      defaultSet: 'fa',
      aliases,
      sets: {
        fa,
      }
    },
    theme: {
      defaultTheme: 'light',
      themes: { //뷰티파이의 변수값 할당 위함
        light: {
          variables: {
            // 'field-input-padding-top': '12px',
            // 'field-input-padding-bottom': '12px', //var(--v-field-input-padding-bottom) 라고 되어있는 부분 할당을 위해선 이렇게 함
            // 'field-padding-start': '12px',
            // 'field-padding-end': '12px',
          }
        }
      }
    }
  })

  nuxtApp.vueApp.use(vuetify)
})
